import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import type { Therapist } from '../data/therapists';
import { LOCATIONS } from '../data/locations';
type TherapistCardProps = {
  therapist: Therapist;
  index?: number;
};
export function TherapistCard({
  therapist,
  index = 0
}: TherapistCardProps) {
  const studio = LOCATIONS.find(l => l.slug === therapist.locationSlug);
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: Math.min(index, 5) * 0.06,
    ease: 'easeOut'
  }} className="group relative overflow-hidden rounded-2xl border border-white/[0.07] bg-ink-850 transition-all duration-300 hover:border-lotus-500/60" data-id="element-123" data-mp="dbn2433rayeq">
      <Link to={`/therapists/${therapist.slug}`} className="block" data-id="element-124" data-mp="2p3k2fe6kbgl3">
        <div className="relative overflow-hidden" data-id="element-125" data-mp="2k4749xa8qn37">
          <img src={therapist.image} alt={`${therapist.name}, massage therapist`} className="h-[420px] w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" loading="lazy" data-id="element-126" data-mp="2k3fmpqdhapvx" />
          <span className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/40 to-transparent" data-id="element-127" data-mp="1g01y5d2op1w5" />
          <span className="absolute inset-0 opacity-40 mix-blend-soft-light transition-opacity duration-500 group-hover:opacity-75" style={{
          backgroundImage: 'linear-gradient(150deg, rgba(232,54,127,0.6) 0%, rgba(168,85,247,0.5) 100%)'
        }} data-id="element-128" data-mp="1kxu0l10yg6el" />

          <div className="absolute inset-x-0 bottom-0 p-6" data-id="element-129" data-mp="xac1slj9w824">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-lotus-300" data-id="element-130" data-mp="127vrchlf879d">
              {therapist.origin} · {therapist.experience}
            </p>
            <h3 className="mt-2 font-display text-3xl font-light tracking-wide text-white" data-id="element-131" data-mp="ncxxtlejdbqp">
              {therapist.name}
            </h3>
            <p className="mt-2 text-sm font-light italic text-orchid-200" data-id="element-132" data-mp="95uq4r4dy9pp">{therapist.tagline}</p>
            {studio && <p className="mt-3 text-xs font-light text-neutral-400" data-id="element-133" data-mp="4dugu82fe4gg">{studio.suburb} location</p>}
            <span className="mt-4 inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.24em] text-lotus-400" data-id="element-134" data-mp="3vlfcgjf2xv9o">
              View profile
              <ArrowRightIcon className="h-3 w-3 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-135" data-mp="s4qe3kpnhrv3" />
            </span>
          </div>
        </div>
      </Link>
    </motion.article>;
}